import { routeAccess } from 'app/access';
import RequireAuth from 'app/components/RequireAuth';
import { lazy } from 'react';
import { Route } from 'react-router';

const SettledDataRoute = lazy(() => import('./settled-data/SettledDataRoute'));
const AgreementsRoute = lazy(() => import('./agreements/AgreementsRoute'));
const CreateAgreementRoute = lazy(() => import('./agreements/CreateAgreementRoute'));
const AgreementRoute = lazy(() => import('./agreements/AgreementRoute'));
const ClearingMappingsRoute = lazy(() => import('./clearing-mappings/ClearingMappingsRoute'));
const CreateClearingMappingRoute = lazy(() => import('./clearing-mappings/CreateClearingMappingRoute'));
const ClearingMappingRoute = lazy(() => import('./clearing-mappings/ClearingMappingRoute/index'));
const AccountingMappingsRoute = lazy(() => import('./accounting-mappings/AccountingMappingsRoute'));
const AccountingMappingRoute = lazy(() => import('./accounting-mappings/AccountingMappingRoute'));
const CreateAccountingMappingRoute = lazy(() => import('./accounting-mappings/CreateAccountingMappingRoute'));
const AccountingRulesRoute = lazy(() => import('./accounting-rules/AccountingRulesRoute'));
const CreateAccountingRuleRoute = lazy(() => import('./accounting-rules/CreateAccountingRuleRoute'));
const AccountingRuleRoute = lazy(() => import('./accounting-rules/AccountingRuleRoute'));

export const ClearingRoutes = [
  <Route
    key="settled-data"
    path="/settled-data"
    element={
      <RequireAuth {...routeAccess.settledData}>
        <SettledDataRoute />
      </RequireAuth>
    }
  />,
];

export const ClearingWithChartOfAccountsRoutes = [
  <Route
    key="agreements"
    path="agreements"
    element={
      <RequireAuth {...routeAccess.agreements}>
        <AgreementsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="agreements-new"
    path="agreements/new"
    element={
      <RequireAuth {...routeAccess.clearingCreate}>
        <CreateAgreementRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="agreements-id"
    path="agreements/:id"
    element={
      <RequireAuth {...routeAccess.agreements}>
        <AgreementRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="clearing-mappings"
    path="clearing-mappings"
    element={
      <RequireAuth {...routeAccess.clearingMappings}>
        <ClearingMappingsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="clearing-mappings-new"
    path="clearing-mappings/new"
    element={
      <RequireAuth {...routeAccess.clearingCreate}>
        <CreateClearingMappingRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="clearing-mappings-id"
    path="clearing-mappings/:id"
    element={
      <RequireAuth {...routeAccess.clearingMappings}>
        <ClearingMappingRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="accounting-mappings"
    path="accounting-mappings"
    element={
      <RequireAuth {...routeAccess.accountingMappings}>
        <AccountingMappingsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="accounting-mappings-new"
    path="accounting-mappings/new"
    element={
      <RequireAuth {...routeAccess.accountingMappingsCreate}>
        <CreateAccountingMappingRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="accounting-mappings-id"
    path="accounting-mappings/:id"
    element={
      <RequireAuth {...routeAccess.accountingMappings}>
        <AccountingMappingRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="accounting-rules"
    path="accounting-rules"
    element={
      <RequireAuth {...routeAccess.accountingRules}>
        <AccountingRulesRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="accounting-rules-new"
    path="accounting-rules/new"
    element={
      <RequireAuth {...routeAccess.clearingCreate}>
        <CreateAccountingRuleRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="accounting-rules-id"
    path="accounting-rules/:id"
    element={
      <RequireAuth {...routeAccess.accountingRules}>
        <AccountingRuleRoute />
      </RequireAuth>
    }
  />,
];
